import React from 'react';
import { Course } from '../../types/grades';
import { GripVertical, Trash2 } from 'lucide-react';
import { useUniversity } from '../../contexts/UniversityContext';
import { CourseCodeInput } from './inputs/CourseCodeInput';
import { CourseCreditsInput } from './inputs/CourseCreditsInput';
import { CourseGradeSelect } from './inputs/CourseGradeSelect';
import { CourseFlags } from './inputs/CourseFlags';

interface CourseInputProps {
  course: Course;
  onChange: (updatedCourse: Course) => void;
  onDelete: () => void;
  index: number;
  setNodeRef?: (node: HTMLElement | null) => void;
  attributes?: any;
  listeners?: any;
  style?: React.CSSProperties;
  isDragging?: boolean;
}

export function CourseInput({ 
  course, 
  onChange, 
  onDelete, 
  index,
  setNodeRef, 
  attributes, 
  listeners, 
  style,
  isDragging 
}: CourseInputProps) {
  const { selectedUniversity } = useUniversity();

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 pl-12 
                 ${isDragging ? 'shadow-lg ring-2 ring-blue-500 opacity-75' : ''}`}
    >
      <button
        {...attributes}
        {...listeners}
        className="absolute left-2 top-1/2 -translate-y-1/2 cursor-grab active:cursor-grabbing p-2 
                   text-gray-400 hover:text-gray-600 touch-none select-none"
        type="button"
        aria-label="Drag to reorder"
      >
        <GripVertical size={20} />
      </button>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.5fr,1fr,1fr,auto] gap-4 p-4">
        <CourseCodeInput course={course} onChange={onChange} />
        <CourseCreditsInput course={course} onChange={onChange} />
        <CourseGradeSelect 
          course={course} 
          onChange={onChange} 
          gradeScale={selectedUniversity.gradeScale} 
        />
        <button
          onClick={onDelete}
          className="p-2 text-red-600 hover:bg-red-50 rounded-full transition-colors"
          title="Delete course"
        >
          <Trash2 size={20} />
        </button>
      </div>
      
      <div className="px-4 pb-4">
        <CourseFlags course={course} onChange={onChange} />
      </div>
    </div>
  );
}